import "./SelectItemComp.css";
import { defineComponent as V, useCssVars as M, resolveComponent as d, openBlock as s, createElementBlock as r, normalizeClass as b, normalizeStyle as _, createVNode as n, withCtx as o, renderSlot as i, normalizeProps as T, guardReactiveProps as B, createElementVNode as h, toDisplayString as u, Fragment as f, renderList as $, createBlock as g, createCommentVNode as v, createTextVNode as A } from "vue";
import { IconComp as I } from "./IconComp.js";
import { ButtonComp as O } from "./ButtonComp.js";
import { OverflowComp as N } from "./OverflowComp.js";
import { V as P, W as D } from "./WrapperComp.f674f2c9.js";
import { u as F } from "./uniqueId.f48d78c2.js";
import { i as E } from "./isNil.6f60d6a4.js";
import { _ as W } from "./_plugin-vue_export-helper.dad06003.js";
const m = V({
  name: "select-item-comp",
  mixins: [P],
  components: {
    IconComp: I,
    ButtonComp: O,
    OverflowComp: N,
    WrapperComp: D
  },
  events: {
    "update:modelValue": {
      type: Object,
      Note: "Emits selected object back"
    },
    "update:errorMessages": {
      type: Array,
      Note: "Emits selected object back"
    }
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => F("selectComp")
    },
    modelValue: {
      type: Object,
      default: null,
      Note: "This is the actual v-model of the component"
    },
    options: {
      type: Array,
      required: !0
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    infoMessages: {
      type: Array,
      default: () => []
    },
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    },
    label: String,
    supportingText: String,
    placeholder: String,
    persistentTitle: String,
    medium: Boolean,
    selectWhite: Boolean,
    selectGray: Boolean,
    blank: Boolean,
    height: String,
    width: String,
    disabled: Boolean,
    labelAbove: Boolean,
    emptyText: String,
    buttonAriaLabel: String,
    labelSpecialText: String,
    labelIcon: String,
    lockOverflowDirection: Boolean
  },
  data() {
    return {
      isFocused: !1
    };
  },
  computed: {
    selectedValue() {
      return this.modelValue ? this.modelValue.text : this.placeholder;
    },
    styleOverides() {
      return {
        height: this.height,
        width: this.width
      };
    },
    selectClasses() {
      return {
        select: !0,
        "select--disabled": this.disabled
      };
    },
    buttonClasses() {
      return {
        select__button: !0,
        "select__button--disabled": this.disabled,
        "select__button--error": this.isErrorState
      };
    },
    hasPlaceholder() {
      var e;
      return !!((e = this.placeholder) != null && e.trim());
    },
    filled() {
      return !E(this.modelValue);
    }
  },
  methods: {
    handleClick(e, t) {
      this.$emit("update:modelValue", e), t();
    },
    blur() {
      this.isFocused = !1, this.validateInputOnBlur();
    },
    open() {
      this.isFocused = !0;
    },
    validate() {
      const e = this.runValidationMethod(this.modelValue);
      return this.$emit("update:errorMessages", e), e.filter((t) => t.id === this.id);
    }
  },
  watch: {
    modelValue() {
      this.blur();
    }
  }
}), y = () => {
  M((e) => ({
    63786302: e.width
  }));
}, w = m.setup;
m.setup = w ? (e, t) => (y(), w(e, t)) : y;
const j = {
  key: 0,
  class: "select__overflowHeader"
}, R = {
  key: 2,
  class: "select__underline"
};
function G(e, t, q, z, L, H) {
  const S = d("icon-comp"), p = d("button-comp"), C = d("overflow-comp"), k = d("wrapper-comp");
  return s(), r("div", {
    class: b(e.selectClasses),
    style: _(e.styleOverides)
  }, [
    n(k, {
      id: e.id,
      label: e.label,
      labelSpecialText: e.labelSpecialText,
      labelIcon: e.labelIcon,
      supportingText: e.supportingText,
      validationRules: e.validationRules,
      errorMessages: e.errorMessages,
      infoMessages: e.infoMessages,
      disableMessages: e.disableMessages,
      labelAbove: e.labelAbove,
      disabled: e.disabled,
      hasPlaceholder: e.hasPlaceholder,
      isFocused: e.isFocused,
      filled: e.filled
    }, {
      messages: o((a) => [
        i(e.$slots, "messages", T(B(a)), void 0, !0)
      ]),
      default: o(() => [
        n(C, {
          onPopperClosed: t[0] || (t[0] = (a) => e.blur()),
          onPopperOpened: t[1] || (t[1] = (a) => e.open()),
          offsetDistance: "2px",
          disabled: e.disabled,
          width: e.width,
          locked: e.lockOverflowDirection
        }, {
          button: o(() => [
            i(e.$slots, "overflowButton", {}, () => [
              n(p, {
                xlarge: !e.medium,
                medium: e.medium,
                id: e.id,
                class: b(e.buttonClasses),
                selectWhite: e.selectWhite,
                selectGray: e.selectGray,
                blank: e.blank,
                disabled: e.disabled,
                "aria-label": e.buttonAriaLabel
              }, {
                default: o(() => [
                  i(e.$slots, "selectedOption", { data: e.modelValue }, () => [
                    h("p", null, u(e.persistentTitle ?? e.selectedValue), 1)
                  ], !0),
                  n(S, { icon: "expand_more_small" })
                ]),
                _: 3
              }, 8, ["xlarge", "medium", "id", "class", "selectWhite", "selectGray", "blank", "disabled", "aria-label"])
            ], !0)
          ]),
          content: o(({ close: a }) => [
            i(e.$slots, "overflowContent", { close: a }, () => [
              (s(!0), r(f, null, $(e.options, (l) => {
                var c;
                return s(), r(f, {
                  key: l.text
                }, [
                  l.readOnly ? (s(), r("p", j, u(l.text), 1)) : (s(), g(p, {
                    key: 1,
                    onClick: (U) => e.handleClick(l, a),
                    dropdown: "",
                    dropdownSelected: !l.header && l.value === ((c = e.modelValue) == null ? void 0 : c.value),
                    dropdownDisabled: l.disabled,
                    prependIcon: l.icon,
                    "t-sel": l.tSel
                  }, {
                    default: o(() => [
                      i(e.$slots, "option", { data: l }, () => [
                        h("p", null, u(l.text), 1)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "dropdownSelected", "dropdownDisabled", "prependIcon", "t-sel"])),
                  l.isUnderlined ? (s(), r("div", R)) : v("", !0)
                ], 64);
              }), 128)),
              e.options.length <= 0 ? (s(), g(p, {
                key: 0,
                dropdown: "",
                dropdownDisabled: ""
              }, {
                default: o(() => [
                  A(u(e.emptyText), 1)
                ]),
                _: 1
              })) : v("", !0)
            ], !0)
          ]),
          _: 3
        }, 8, ["disabled", "width", "locked"])
      ]),
      _: 3
    }, 8, ["id", "label", "labelSpecialText", "labelIcon", "supportingText", "validationRules", "errorMessages", "infoMessages", "disableMessages", "labelAbove", "disabled", "hasPlaceholder", "isFocused", "filled"])
  ], 6);
}
const te = /* @__PURE__ */ W(m, [["render", G], ["__scopeId", "data-v-1e0fb0c9"]]);
export {
  te as SelectItemComp
};
//# sourceMappingURL=SelectItemComp.js.map
